"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const GeoJSON_1 = require("./GeoJSON");
const Image_1 = require("./Image");
const YanziModel_1 = require("./YanziModel");
function Layer(_a) {
    var { layer } = _a, props = __rest(_a, ["layer"]);
    react_1.useEffect(() => {
        if (layer.layerType !== 'floorplan') {
            console.warn('Unknown layer type', layer.layerType, 'expected "floorplan"');
        }
    }, [layer.layerType]);
    if (layer.layerType !== 'floorplan') {
        return null;
    }
    if (layer.contentType === 'application/vnd.geo+json') {
        const { autoCenter } = props, p = __rest(props, ["autoCenter"]);
        return jsx_runtime_1.jsx(GeoJSON_1.GeoJSON, Object.assign({ layer: layer }, p), void 0);
    }
    if (layer.contentType === 'application/yanzi.model') {
        const { autoCenter } = props, p = __rest(props, ["autoCenter"]);
        return jsx_runtime_1.jsx(YanziModel_1.YanziModel, Object.assign({ layer: layer }, p), void 0);
    }
    if (layer.contentType === 'image/png') {
        return jsx_runtime_1.jsx(Image_1.ImageLayer, Object.assign({ layer: layer }, props), void 0);
    }
    return null;
}
exports.Layer = Layer;
exports.default = Layer;
//# sourceMappingURL=index.js.map